
export const handleAdminStaffSearch = (e: any, setSearchQuery: Function, navigate: Function) => {
    const userRole = localStorage.getItem("ROLE");
  if (userRole === "admin") {
        if (e?.target?.value?.length > 2) {
            setSearchQuery(e?.target?.value)
            navigate(`/admin/magazine/1`);
        }
        else {
            setSearchQuery('')
        }
    }
    else {
        if (e?.target?.value?.length > 2) {
            setSearchQuery(e?.target?.value)
            navigate(`/member/magazine/1`);
        }
        else {
            setSearchQuery('')
        } 
    }

}